import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axiosConfig from '../config/axiosConfig';

const WalletContext = createContext(null);

export const useWallet = () => {
  const ctx = useContext(WalletContext);
  if (!ctx) {
    return {
      planStatus: null,
      loadingPlanStatus: false,
      refreshPlanStatus: () => Promise.resolve(null),
    };
  }
  return ctx;
};

export const WalletProvider = ({ children }) => {
  const [planStatus, setPlanStatus] = useState(null);
  const [loadingPlanStatus, setLoadingPlanStatus] = useState(true);

  const refreshPlanStatus = useCallback(async () => {
    try {
      setLoadingPlanStatus(true);
      const effectiveId = sessionStorage.getItem('effective_company_id') || sessionStorage.getItem('customeruuid');
      const params = effectiveId ? { companyid: effectiveId } : undefined;
      const response = await axiosConfig.get('/wallet/plan-status', { params });
      const entity = response.data?.entity || null;
      setPlanStatus(entity);
      return entity;
    } catch {
      setPlanStatus(null);
      return null;
    } finally {
      setLoadingPlanStatus(false);
    }
  }, []);

  useEffect(() => {
    refreshPlanStatus();
  }, [refreshPlanStatus]);

  return (
    <WalletContext.Provider
      value={{
        planStatus,
        loadingPlanStatus,
        refreshPlanStatus,
      }}
    >
      {children}
    </WalletContext.Provider>
  );
};
